import { createSlice } from "@reduxjs/toolkit";

const normalizeSelectionValue = (value) => {
  if (value === null || value === undefined || value === 0) {
    return "";
  }
  return value;
};

const initialState = {
  testCases: [],
  tsrData: [],
  selectedProduct: "",
  selectedComponent: "",
  selectedTestCase: "",
  selectedTestcaseItem: {},
  recordings: [],
  editItemIndex: null,
  editStep: {},
  isMobile: false,
  tabs: [],
};

const authoringSlice = createSlice({
  name: "testAuthoring",
  initialState,
  reducers: {
    setTestCases(state, action) {
      state.testCases = action.payload;
    },
    setTsrData(state, action) {
      state.tsrData = action.payload;
    },
    setSelectedProduct(state, action) {
      state.selectedProduct = normalizeSelectionValue(action.payload);
      state.selectedComponent = initialState.selectedComponent;
    },
    setSelectedComponent(state, action) {
      state.selectedComponent = normalizeSelectionValue(action.payload);
      state.selectedTestCase = initialState.selectedTestCase;
    },
    setSelectedTestCase(state, action) {
      state.selectedTestCase = normalizeSelectionValue(action.payload);
    },
    setSelectedTestCaseItem(state, action) {
      state.selectedTestcaseItem = action.payload;
    },
    setRecordings(state, action) {
      state.recordings = action.payload;
    },
    setEditItemIndex(state, action) {
      state.editItemIndex = action.payload;
    },
    setEditStep(state, action) {
      state.editStep = action.payload;
    },
    setIsMobile(state, action) {
      state.isMobile = action.payload;
    },
    resetAuthorings() {
      return { ...initialState };
    },
    setTabs(state, action) {
      state.tabs = action.payload;
    },
  },
});

export const {
  setTestCases,
  setTsrData,
  setSelectedProduct,
  setSelectedComponent,
  setSelectedTestCase,
  setSelectedTestCaseItem,
  resetAuthorings,
  setRecordings,
  setEditItemIndex,
  setEditStep,
  setIsMobile,
  setTabs,
} = authoringSlice.actions;

export default authoringSlice.reducer;
